import { render, staticRenderFns } from "./AddEditDean.vue?vue&type=template&id=5d6292b8"
import script from "./AddEditDean.vue?vue&type=script&lang=js"
export * from "./AddEditDean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports